<template>
	<div class="examples">
		
		<swiper :options="swiperOption" v-if="$route.path === '/services/'">
			<swiper-slide v-for="(item, index) in data" :key="index" v-if="filteredData(item.infograph)">
				<div class="examples-item">
					<router-link class="stretched-link"
					             :to="{path: '/objects/', query:{city: item.city.title ,serv: $route.query.type}}"
					             tag="a">
					</router-link>
					<div class="examples-item-ttl">
						<p>{{item.city.title}}</p>
						<p>{{item.title}}</p>
					</div>
					<div class="examples-item-container">
						<p class="subttl">Количество домов</p>
						<div class="descr d-flex justify-content-start align-items-center">
							<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
								<path
									d="M29.7867 13.9195C29.7848 13.89 29.7834 13.86 29.7777 13.8314C29.7739 13.8105 29.7667 13.7914 29.7605 13.771C29.7534 13.7467 29.7481 13.7219 29.7381 13.6986C29.7296 13.6781 29.7181 13.6591 29.7081 13.6395C29.6977 13.6186 29.6872 13.5967 29.6743 13.5771C29.6629 13.5591 29.6481 13.5433 29.6353 13.5267C29.62 13.5071 29.6053 13.4871 29.5881 13.4695C29.5739 13.4548 29.5577 13.4429 29.542 13.4295C29.5224 13.4129 29.5043 13.3952 29.4829 13.3805C29.4648 13.3681 29.4448 13.3586 29.4253 13.3476C29.4043 13.3357 29.3843 13.3229 29.362 13.3133C29.3372 13.3029 29.311 13.2957 29.2848 13.2876C29.2672 13.2824 29.251 13.2748 29.2329 13.2705L15.7143 10.2633V1.12096C15.7143 0.726196 15.3943 0.406672 15 0.406672H0.922904C0.528142 0.406672 0.208618 0.726196 0.208618 1.12096V28.8791C0.208618 29.2733 0.528142 29.5933 0.922904 29.5933H15H29.0777C29.472 29.5933 29.792 29.2733 29.792 28.8791V13.9681C29.792 13.9514 29.7881 13.9362 29.7867 13.9195ZM1.63719 1.83524H14.2858V10.8243C14.2858 10.8248 14.2858 10.8252 14.2858 10.8257V10.8362V28.1648H11.4843V21.6091C11.4843 21.2148 11.1648 20.8948 10.77 20.8948H5.15243C4.75767 20.8948 4.43814 21.2148 4.43814 21.6091V28.1652H1.63719V1.83524ZM10.0558 28.1648H5.86671V22.3233H10.0558V28.1648ZM24.7167 28.1648H22.7529V22.3233H24.7167V28.1648ZM21.3243 28.1648H19.3605V22.3233H21.3243V28.1648ZM26.1453 28.1648V21.6091C26.1453 21.2148 25.8253 20.8948 25.431 20.8948H18.6462C18.252 20.8948 17.932 21.2148 17.932 21.6091V28.1652H15.7143V11.7271L28.3634 14.5414V28.1652H26.1453V28.1648Z"
									fill="black"/>
								<path
									d="M3.20281 7.71761H6.57376C6.96853 7.71761 7.28805 7.39809 7.28805 7.00333V3.63237C7.28805 3.23761 6.96853 2.91809 6.57376 2.91809H3.20281C2.80805 2.91809 2.48853 3.23761 2.48853 3.63237V7.00333C2.48853 7.39761 2.80805 7.71761 3.20281 7.71761ZM3.9171 4.34666H5.85948V6.28904H3.9171V4.34666Z"
									fill="black"/>
								<path
									d="M9.34905 7.71761H12.72C13.1148 7.71761 13.4343 7.39809 13.4343 7.00333V3.63237C13.4343 3.23761 13.1148 2.91809 12.72 2.91809H9.34905C8.95429 2.91809 8.63477 3.23761 8.63477 3.63237V7.00333C8.63477 7.39761 8.95477 7.71761 9.34905 7.71761ZM10.0633 4.34666H12.0057V6.28904H10.0633V4.34666Z"
									fill="black"/>
								<path
									d="M6.57329 19.7462C6.96805 19.7462 7.28757 19.4262 7.28757 19.0319V15.6614C7.28757 15.2671 6.96805 14.9471 6.57329 14.9471H3.20281C2.80805 14.9471 2.48853 15.2671 2.48853 15.6614V19.0319C2.48853 19.4262 2.80805 19.7462 3.20281 19.7462H6.57329ZM3.9171 16.3757H5.85948V18.3176H3.9171V16.3757Z"
									fill="black"/>
								<path
									d="M9.34905 19.7462H12.72C13.1148 19.7462 13.4343 19.4262 13.4343 19.0319V15.6614C13.4343 15.2671 13.1148 14.9471 12.72 14.9471H9.34905C8.95429 14.9471 8.63477 15.2671 8.63477 15.6614V19.0319C8.63477 19.4262 8.95477 19.7462 9.34905 19.7462ZM10.0633 16.3757H12.0057V18.3176H10.0633V16.3757Z"
									fill="black"/>
								<path
									d="M3.20281 13.7314H6.57376C6.96853 13.7314 7.28805 13.4119 7.28805 13.0171V9.64618C7.28805 9.25142 6.96853 8.9319 6.57376 8.9319H3.20281C2.80805 8.9319 2.48853 9.25142 2.48853 9.64618V13.0171C2.48853 13.4119 2.80805 13.7314 3.20281 13.7314ZM3.9171 10.3609H5.85948V12.3033H3.9171V10.3609Z"
									fill="black"/>
								<path
									d="M9.34905 13.7314H12.72C13.1148 13.7314 13.4343 13.4119 13.4343 13.0171V9.64618C13.4343 9.25142 13.1148 8.9319 12.72 8.9319H9.34905C8.95429 8.9319 8.63477 9.25142 8.63477 9.64618V13.0171C8.63477 13.4119 8.95477 13.7314 9.34905 13.7314ZM10.0633 10.3609H12.0057V12.3033H10.0633V10.3609Z"
									fill="black"/>
								<path
									d="M20.6504 15.0529H17.28C16.8857 15.0529 16.5657 15.3729 16.5657 15.7671V19.1376C16.5657 19.5319 16.8857 19.8519 17.28 19.8519H20.6504C21.0447 19.8519 21.3647 19.5319 21.3647 19.1376V15.7671C21.3647 15.3729 21.0447 15.0529 20.6504 15.0529ZM19.9362 18.4233H17.9942V16.4814H19.9362V18.4233Z"
									fill="black"/>
								<path
									d="M26.7972 15.0529H23.4267C23.0324 15.0529 22.7124 15.3729 22.7124 15.7671V19.1376C22.7124 19.5319 23.0324 19.8519 23.4267 19.8519H26.7972C27.1915 19.8519 27.5115 19.5319 27.5115 19.1376V15.7671C27.5115 15.3729 27.1919 15.0529 26.7972 15.0529ZM26.0829 18.4233H24.141V16.4814H26.0829V18.4233Z"
									fill="black"/>
							</svg>
							<p class="num">{{item.text}}</p>
						</div>
						<p class="subttl">Срок сдачи объекта</p>
						<div class="descr d-flex justify-content-start align-items-center">
							<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
								<path
									d="M14.9993 0C6.7284 0 0 6.72906 0 14.9993C0 23.2709 6.72906 30 15 30C23.2703 30 29.9993 23.2709 29.9993 15C29.9993 6.72906 23.2703 0 14.9993 0ZM15 26.7124C8.54184 26.7124 3.2876 21.4575 3.2876 14.9993C3.2876 8.54118 8.54184 3.2876 15 3.2876C21.4575 3.2876 26.7117 8.54184 26.7117 14.9993C26.7117 21.4575 21.4575 26.7124 15 26.7124Z"
									fill="#A4A4A4"/>
								<path
									d="M19.8774 13.3562H16.6326V6.78232C16.6326 5.87428 15.8968 5.13852 14.9888 5.13852C14.0807 5.13852 13.345 5.87428 13.345 6.78232V15C13.345 15.908 14.0807 16.6438 14.9888 16.6438C14.9914 16.6438 14.9934 16.6431 14.996 16.6431C14.998 16.6431 15.0006 16.6438 15.0026 16.6438H19.8774C20.7855 16.6438 21.5212 15.908 21.5212 15C21.5212 14.092 20.7855 13.3562 19.8774 13.3562Z"
									fill="#A4A4A4"/>
							</svg>
							<p class="date">{{item.text2}}</p>
						</div>
						<img class="hidden-img" src="@/assets/img/hidden.png" alt="">
						<div class="hidden-text">Читать подробнее
							<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
								<path d="M2 11V9H14L10 5L11 3L18 10L11 17L10 15L14 11H2Z" fill="white"/>
							</svg>
						</div>
					</div>
					<div class="examples-item-bottom d-flex justify-content-start align-items-center">
						<p class="examples-item-bottom-text">{{$route.query.type}}</p>
					</div>
				</div>
			</swiper-slide>
			<div class="control-container d-flex justify-content-start align-items-center"
			     slot="pagination">
				<div class="control-container-buttons d-none d-lf-flex justify-content-between align-items-center">
					<div class="gallery-swiper-button-prev d-flex justify-content-center align-items-center" slot="button-prev"
					     style="transform: rotate(180deg)">
						<svg xmlns="http://www.w3.org/2000/svg" width="14" height="25" viewBox="0 0 14 25" fill="none">
							<path
								d="M11.568 12.5407L0.711038 23.3977C0.444021 23.6647 0.444021 24.0929 0.711038 24.3599C0.978054 24.6269 1.40629 24.6269 1.6733 24.3599L13.0139 13.0193C13.281 12.7523 13.281 12.324 13.0139 12.057L1.6733 0.721414C1.54232 0.590424 1.36598 0.519893 1.19469 0.519893C1.0234 0.519893 0.847065 0.585387 0.716076 0.721413C0.44906 0.988431 0.44906 1.41666 0.716076 1.68368L11.568 12.5407Z"
								fill="#D08686"/>
						</svg>
					</div>
					<div class="gallery-swiper-button-next d-flex justify-content-center align-items-center" slot="button-next">
						<svg xmlns="http://www.w3.org/2000/svg" width="14" height="25" viewBox="0 0 14 25" fill="none">
							<path
								d="M11.568 12.5407L0.711038 23.3977C0.444021 23.6647 0.444021 24.0929 0.711038 24.3599C0.978054 24.6269 1.40629 24.6269 1.6733 24.3599L13.0139 13.0193C13.281 12.7523 13.281 12.324 13.0139 12.057L1.6733 0.721414C1.54232 0.590424 1.36598 0.519893 1.19469 0.519893C1.0234 0.519893 0.847065 0.585387 0.716076 0.721413C0.44906 0.988431 0.44906 1.41666 0.716076 1.68368L11.568 12.5407Z"
								fill="#D08686"/>
						</svg>
					</div>
				</div>
				<div class="swiper-pagination swiper-pagination-bullets"></div>
			</div>
		</swiper>
		
		<swiper :options="swiperOption" v-else>
			<swiper-slide v-for="(item, index) in filteredServData()" :key="index">
				<div class="examples-item">
					<router-link class="stretched-link"
					             :to="{path: '/objects/', query:{city: 'Тюмень' , serv: title}}" tag="a">
					</router-link>
					<div class="examples-item-ttl">
						<p>{{item.city.title}}</p>
						<p>{{item.title}}</p>
					</div>
					<div class="examples-item-container">
						<p class="subttl">Количество домов</p>
						<div class="descr d-flex justify-content-start align-items-center">
							<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
								<path
									d="M29.7867 13.9195C29.7848 13.89 29.7834 13.86 29.7777 13.8314C29.7739 13.8105 29.7667 13.7914 29.7605 13.771C29.7534 13.7467 29.7481 13.7219 29.7381 13.6986C29.7296 13.6781 29.7181 13.6591 29.7081 13.6395C29.6977 13.6186 29.6872 13.5967 29.6743 13.5771C29.6629 13.5591 29.6481 13.5433 29.6353 13.5267C29.62 13.5071 29.6053 13.4871 29.5881 13.4695C29.5739 13.4548 29.5577 13.4429 29.542 13.4295C29.5224 13.4129 29.5043 13.3952 29.4829 13.3805C29.4648 13.3681 29.4448 13.3586 29.4253 13.3476C29.4043 13.3357 29.3843 13.3229 29.362 13.3133C29.3372 13.3029 29.311 13.2957 29.2848 13.2876C29.2672 13.2824 29.251 13.2748 29.2329 13.2705L15.7143 10.2633V1.12096C15.7143 0.726196 15.3943 0.406672 15 0.406672H0.922904C0.528142 0.406672 0.208618 0.726196 0.208618 1.12096V28.8791C0.208618 29.2733 0.528142 29.5933 0.922904 29.5933H15H29.0777C29.472 29.5933 29.792 29.2733 29.792 28.8791V13.9681C29.792 13.9514 29.7881 13.9362 29.7867 13.9195ZM1.63719 1.83524H14.2858V10.8243C14.2858 10.8248 14.2858 10.8252 14.2858 10.8257V10.8362V28.1648H11.4843V21.6091C11.4843 21.2148 11.1648 20.8948 10.77 20.8948H5.15243C4.75767 20.8948 4.43814 21.2148 4.43814 21.6091V28.1652H1.63719V1.83524ZM10.0558 28.1648H5.86671V22.3233H10.0558V28.1648ZM24.7167 28.1648H22.7529V22.3233H24.7167V28.1648ZM21.3243 28.1648H19.3605V22.3233H21.3243V28.1648ZM26.1453 28.1648V21.6091C26.1453 21.2148 25.8253 20.8948 25.431 20.8948H18.6462C18.252 20.8948 17.932 21.2148 17.932 21.6091V28.1652H15.7143V11.7271L28.3634 14.5414V28.1652H26.1453V28.1648Z"
									fill="black"/>
								<path
									d="M3.20281 7.71761H6.57376C6.96853 7.71761 7.28805 7.39809 7.28805 7.00333V3.63237C7.28805 3.23761 6.96853 2.91809 6.57376 2.91809H3.20281C2.80805 2.91809 2.48853 3.23761 2.48853 3.63237V7.00333C2.48853 7.39761 2.80805 7.71761 3.20281 7.71761ZM3.9171 4.34666H5.85948V6.28904H3.9171V4.34666Z"
									fill="black"/>
								<path
									d="M9.34905 7.71761H12.72C13.1148 7.71761 13.4343 7.39809 13.4343 7.00333V3.63237C13.4343 3.23761 13.1148 2.91809 12.72 2.91809H9.34905C8.95429 2.91809 8.63477 3.23761 8.63477 3.63237V7.00333C8.63477 7.39761 8.95477 7.71761 9.34905 7.71761ZM10.0633 4.34666H12.0057V6.28904H10.0633V4.34666Z"
									fill="black"/>
								<path
									d="M6.57329 19.7462C6.96805 19.7462 7.28757 19.4262 7.28757 19.0319V15.6614C7.28757 15.2671 6.96805 14.9471 6.57329 14.9471H3.20281C2.80805 14.9471 2.48853 15.2671 2.48853 15.6614V19.0319C2.48853 19.4262 2.80805 19.7462 3.20281 19.7462H6.57329ZM3.9171 16.3757H5.85948V18.3176H3.9171V16.3757Z"
									fill="black"/>
								<path
									d="M9.34905 19.7462H12.72C13.1148 19.7462 13.4343 19.4262 13.4343 19.0319V15.6614C13.4343 15.2671 13.1148 14.9471 12.72 14.9471H9.34905C8.95429 14.9471 8.63477 15.2671 8.63477 15.6614V19.0319C8.63477 19.4262 8.95477 19.7462 9.34905 19.7462ZM10.0633 16.3757H12.0057V18.3176H10.0633V16.3757Z"
									fill="black"/>
								<path
									d="M3.20281 13.7314H6.57376C6.96853 13.7314 7.28805 13.4119 7.28805 13.0171V9.64618C7.28805 9.25142 6.96853 8.9319 6.57376 8.9319H3.20281C2.80805 8.9319 2.48853 9.25142 2.48853 9.64618V13.0171C2.48853 13.4119 2.80805 13.7314 3.20281 13.7314ZM3.9171 10.3609H5.85948V12.3033H3.9171V10.3609Z"
									fill="black"/>
								<path
									d="M9.34905 13.7314H12.72C13.1148 13.7314 13.4343 13.4119 13.4343 13.0171V9.64618C13.4343 9.25142 13.1148 8.9319 12.72 8.9319H9.34905C8.95429 8.9319 8.63477 9.25142 8.63477 9.64618V13.0171C8.63477 13.4119 8.95477 13.7314 9.34905 13.7314ZM10.0633 10.3609H12.0057V12.3033H10.0633V10.3609Z"
									fill="black"/>
								<path
									d="M20.6504 15.0529H17.28C16.8857 15.0529 16.5657 15.3729 16.5657 15.7671V19.1376C16.5657 19.5319 16.8857 19.8519 17.28 19.8519H20.6504C21.0447 19.8519 21.3647 19.5319 21.3647 19.1376V15.7671C21.3647 15.3729 21.0447 15.0529 20.6504 15.0529ZM19.9362 18.4233H17.9942V16.4814H19.9362V18.4233Z"
									fill="black"/>
								<path
									d="M26.7972 15.0529H23.4267C23.0324 15.0529 22.7124 15.3729 22.7124 15.7671V19.1376C22.7124 19.5319 23.0324 19.8519 23.4267 19.8519H26.7972C27.1915 19.8519 27.5115 19.5319 27.5115 19.1376V15.7671C27.5115 15.3729 27.1919 15.0529 26.7972 15.0529ZM26.0829 18.4233H24.141V16.4814H26.0829V18.4233Z"
									fill="black"/>
							</svg>
							<p class="num">{{item.text}}</p>
						</div>
						<p class="subttl">Срок сдачи объекта</p>
						<div class="descr d-flex justify-content-start align-items-center">
							<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
								<path
									d="M14.9993 0C6.7284 0 0 6.72906 0 14.9993C0 23.2709 6.72906 30 15 30C23.2703 30 29.9993 23.2709 29.9993 15C29.9993 6.72906 23.2703 0 14.9993 0ZM15 26.7124C8.54184 26.7124 3.2876 21.4575 3.2876 14.9993C3.2876 8.54118 8.54184 3.2876 15 3.2876C21.4575 3.2876 26.7117 8.54184 26.7117 14.9993C26.7117 21.4575 21.4575 26.7124 15 26.7124Z"
									fill="#A4A4A4"/>
								<path
									d="M19.8774 13.3562H16.6326V6.78232C16.6326 5.87428 15.8968 5.13852 14.9888 5.13852C14.0807 5.13852 13.345 5.87428 13.345 6.78232V15C13.345 15.908 14.0807 16.6438 14.9888 16.6438C14.9914 16.6438 14.9934 16.6431 14.996 16.6431C14.998 16.6431 15.0006 16.6438 15.0026 16.6438H19.8774C20.7855 16.6438 21.5212 15.908 21.5212 15C21.5212 14.092 20.7855 13.3562 19.8774 13.3562Z"
									fill="#A4A4A4"/>
							</svg>
							<p class="date">{{item.text2}}</p>
						</div>
						<img class="hidden-img" src="@/assets/img/hidden.png" alt="">
						<div class="hidden-text">Читать подробнее
							<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
								<path d="M2 11V9H14L10 5L11 3L18 10L11 17L10 15L14 11H2Z" fill="white"/>
							</svg>
						</div>
					</div>
					<div class="examples-item-bottom d-flex justify-content-start align-items-center">
						<p class="examples-item-bottom-text">{{title}}</p>
					</div>
				</div>
			</swiper-slide>
			<div class="control-container d-flex justify-content-start align-items-center"
			     slot="pagination">
				<div class="control-container-buttons d-none d-lf-flex justify-content-between align-items-center">
					<div class="gallery-swiper-button-prev d-flex justify-content-center align-items-center" slot="button-prev"
					     style="transform: rotate(180deg)">
						<svg xmlns="http://www.w3.org/2000/svg" width="14" height="25" viewBox="0 0 14 25" fill="none">
							<path
								d="M11.568 12.5407L0.711038 23.3977C0.444021 23.6647 0.444021 24.0929 0.711038 24.3599C0.978054 24.6269 1.40629 24.6269 1.6733 24.3599L13.0139 13.0193C13.281 12.7523 13.281 12.324 13.0139 12.057L1.6733 0.721414C1.54232 0.590424 1.36598 0.519893 1.19469 0.519893C1.0234 0.519893 0.847065 0.585387 0.716076 0.721413C0.44906 0.988431 0.44906 1.41666 0.716076 1.68368L11.568 12.5407Z"
								fill="#D08686"/>
						</svg>
					</div>
					<div class="gallery-swiper-button-next d-flex justify-content-center align-items-center" slot="button-next">
						<svg xmlns="http://www.w3.org/2000/svg" width="14" height="25" viewBox="0 0 14 25" fill="none">
							<path
								d="M11.568 12.5407L0.711038 23.3977C0.444021 23.6647 0.444021 24.0929 0.711038 24.3599C0.978054 24.6269 1.40629 24.6269 1.6733 24.3599L13.0139 13.0193C13.281 12.7523 13.281 12.324 13.0139 12.057L1.6733 0.721414C1.54232 0.590424 1.36598 0.519893 1.19469 0.519893C1.0234 0.519893 0.847065 0.585387 0.716076 0.721413C0.44906 0.988431 0.44906 1.41666 0.716076 1.68368L11.568 12.5407Z"
								fill="#D08686"/>
						</svg>
					</div>
				</div>
				<div class="swiper-pagination swiper-pagination-bullets"></div>
			</div>
		</swiper>
	
	
	</div>
</template>

<script>
	//const axios = require('axios');
	export default {
		props: {
			data: Object
		},
		data () {
			return {
				title: '',
				sortedServ: null,
				swiperOption: {
					slidesPerView: 4,
					spaceBetween: 30,
					loop: false,
					breakpoints: {
						768: {
							slidesPerView: 1,
							spaceBetween: 5,
						}
					},
					pagination: {
						el: '.swiper-pagination',
						clickable: true,
						renderBullet (index, className) {
							return `<span class="${className} swiper-pagination-bullet-custom"></span>`
						}
					},
					navigation: {
						nextEl: '.gallery-swiper-button-next',
						prevEl: '.gallery-swiper-button-prev'
					}
				}
			}
		},
		methods: {
			filteredData (info) {
				let show = false
				for (let key of info) {
					if (show || key.servcat.title === this.$route.query.type) {
						show = true
					}
				}
				return show
			},
			filteredServData () {
				const items = this.data
				const filtered = []
				
				for (let item in items) {
					
					items[item].infograph.forEach(info => {
						
						if (this.$route.path === info.serv.url) {
							this.title = info.serv.title
							filtered.push(items[item])
						}
					})
				}
				
				return filtered
			},
		}
	}
</script>

<style lang="scss" scoped>
	
	.examples {
		
		.swiper-container {
			.swiper-pagination {
				left: 50%;
				transform: translateX(-50%);
				@media only screen and (max-width: $sm), only screen and (max-device-width: $sm) {
					width: 100%;
				}
			}
			
			.swiper-wrapper {
				margin-bottom: 20px;
			}
			
			.swiper-slide {
				.slide-item-container {
					width: 210px;
					height: 110px;
					border: 2px solid #F6F6F6;
				}
				
			}
		}
		
		.control-container-buttons {
			width: 94px;
			height: 40px;
			background: rgba(208, 134, 134, 0.4);
			border: 1px solid #D08686;
			box-sizing: border-box;
			border-radius: 70px;
			
			.gallery-swiper-button-next, .gallery-swiper-button-prev {
				height: 100%;
				width: 50%;
			}
			
			.swiper-button-disabled {
				svg {
					path {
						fill: #FFFFFF;
					}
				}
			}
		}
		
		&-item {
			background-color: #FFFFFF;
			position: relative;
			
			&-ttl {
				height: 104px;
				padding: 20px 0 10px 30px;
				
				p {
					font-weight: 500;
					font-size: 18px;
					line-height: 100%;
					color: $mainFontColor;
					margin-bottom: 10px;
				}
			}
			
			&-container {
				transition: all 0.3s ease-in-out;
				position: relative;
				overflow: hidden;
				
				.subttl {
					border-top: 1px solid #EFEFEF;
					padding: 15px;
					font-weight: 700;
					font-size: 12px;
					line-height: 100%;
					text-transform: uppercase;
					color: $secondFontColor;
					transition: all 0.6s ease-in-out;
					
				}
				
				.descr {
					transition: all 0.6s ease-in-out;
					
					svg {
						margin-left: 30px;
						margin-right: 20px;
						margin-bottom: 15px;
					}
					
					.num {
						font-weight: 500;
						font-size: 32px;
						line-height: 100%;
						color: $mainFontColor;
						margin-bottom: 15px;
					}
					
					.date {
						font-weight: 800;
						font-size: 22px;
						line-height: 100%;
						color: $secondFontColor;
						margin-bottom: 15px;
					}
				}
				
				.hidden-img {
					position: absolute;
					top: 0;
					transform: translateY(100%);
					transition: all 0.5s ease-in-out;
					transition-delay: 0.3s;
					object-fit: cover;
					width: 100%;
					height: 100%;
				}
				
				.hidden-text {
					width: 100%;
					color: #FFF;
					font-weight: 800;
					font-size: 14px;
					line-height: 18px;
					position: absolute;
					text-align: center;
					bottom: -20px;
					left: 50%;
					transform: translateX(-50%);
					transition: all 0.3s ease-in-out;
					transition-delay: 0.5s;
					
					svg {
						margin-left: 12px;
					}
				}
				
			}
			
			&:hover {
				.subttl, .descr {
					opacity: 0;
					transform: translateY(-100%);
				}
				
				.hidden-img {
					transform: translateY(0);
				}
				
				.hidden-text {
					bottom: 17px;
				}
			}
			
			&-bottom {
				padding: 6px 0px 6px 30px;
				height: 42px;
				background-color: $bg1Color;
				
				svg {
					margin-right: 15px;
				}
				
				&-text {
					font-weight: 800;
					font-size: 12px;
					line-height: 100%;
					text-transform: uppercase;
					color: $activeColor;
					
				}
			}
		}
	}

</style>